import { sessionStoragePersister } from '~/shared/storages'

const DIGITAL_LECTURE_SKIP_AUTH_PREFIX = 'digital-lecture'

export const getDigitalLectureSkipAuthKey = (slug: string): string =>
  `${DIGITAL_LECTURE_SKIP_AUTH_PREFIX}-${slug}-skip-auth`

export const hasDigitalLectureSkipAuth = (slug: string): boolean => {
  if (!slug) {
    return false
  }

  return sessionStoragePersister.getItem<boolean>(getDigitalLectureSkipAuthKey(slug)) === true
}

export const setDigitalLectureSkipAuth = (slug: string): void => {
  if (!slug) {
    return
  }

  sessionStoragePersister.setItem(getDigitalLectureSkipAuthKey(slug), true)
}
